/** One cancellable operation per worker. Completion and cancellation settle
 * once, so queued messages can never revive an obsolete operation. */
export function workerTask(worker, payload, onProgress = () => {}, onResultMessage) {
  let cancel, settled = false;
  const result = new Promise((resolve, reject) => {
    const finish = (error, value) => {
      if (settled) return;
      settled = true; worker.terminate();
      if (error) reject(error); else resolve(value);
    };
    cancel = () => finish(new DOMException('Operation cancelled', 'AbortError'));
    worker.onmessage = ({ data }) => {
      if (settled) return;
      if (data.type === 'progress') onProgress(data.p, data.msg);
      else if (data.type === 'result') { try { onResultMessage?.(data); } catch { /* extras are optional */ } finish(null, data.result); }
      else if (data.type === 'error') finish(new Error(data.message));
    };
    worker.onerror = event => { event.preventDefault?.(); finish(new Error(event.message || 'The background operation failed. Please try again.')); };
    worker.onmessageerror = () => finish(new Error('The background result could not be read. Please try again.'));
    try { worker.postMessage(payload); } catch (error) { finish(error); }
  });
  return { result, cancel: () => cancel() };
}
